import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-service-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = { class: "actions" }

import { computed, ref } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppTextArea from "@/shared/components/ui/AppTextArea.vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";

type ServiceOption = {
  service_name: string;
  subtitle: string;
  price?: string | number | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddServiceModal',
  props: {
    onAdd: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();

const title = ref("");
const subtitle = ref("");
const price = ref<string | number | "">("");

// Error messages for validation
const titleError = ref("");
const subtitleError = ref("");
const priceError = ref("");

function handleSubmit() {
  // Clear previous errors
  titleError.value = "";
  subtitleError.value = "";
  priceError.value = "";

  const t = title.value.trim();
  if (!t) {
    titleError.value = "Service name is required";
    return;
  }

  const trimmedSubtitle = subtitle.value.trim();
  if (trimmedSubtitle.length > 250) {
    subtitleError.value = "Description must be 250 characters or less";
    return;
  }

  const servicePrice = price.value === "" ? null : price.value;
  const numericPrice = servicePrice === null ? null : Number(servicePrice);
  if (servicePrice === null || Number.isNaN(numericPrice) || numericPrice <= 0) {
    priceError.value = "Service price is required and must be greater than 0";
    return;
  }

  const service: ServiceOption = {
    service_name: t,
    subtitle: trimmedSubtitle,
    price: numericPrice,
  };

  props.onAdd?.(service);
  modal.close();
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-title" }, "Add service", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          class: "form",
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(AppTextField, {
              modelValue: title.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event)),
                _cache[2] || (_cache[2] = ($event: any) => (titleError.value = ''))
              ],
              label: "Service name",
              placeholder: "e.g., Ant control",
              "error-messages": titleError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(AppTextArea, {
              modelValue: subtitle.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((subtitle).value = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (subtitleError.value = ''))
              ],
              label: "Description",
              placeholder: "Short description...",
              rows: "4",
              "error-messages": subtitleError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(AppTextField, {
              modelValue: price.value,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((price).value = $event)),
                _cache[6] || (_cache[6] = ($event: any) => (priceError.value = ''))
              ],
              type: "number",
              label: "Price",
              placeholder: "0.00",
              "error-messages": priceError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AppButtonFlat, {
                block: "",
                type: "submit",
                "prepend-icon": "mdi-check",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Submit ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})